import { Box, Button, TextField } from '@mui/material';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import GlobalDialogContent from '../GlobalDialogContent';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../redux/store';
import { closeDialog } from '../../../redux/reducer/dialogSlice';
import { showSnackbar } from '../../../redux/reducer/snackbarSlice';
import { setModuleRefresh } from '../../../redux/reducer/registration/RefreshSlice';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { UpdateTPMStatus } from '../../../utils/services/tri-party-mou/tri.party.mou.service';

export default function TPMApproveReject() {
    const dispatch = useDispatch();
    const { status, payload } = useSelector((state: RootState) => state.dialog);
    const [searchParams] = useSearchParams();
    const uuid = searchParams.get("uuid");
    const [loading, setloading] = useState(false);

    const validationSchema = Yup.object().shape({
        comments: Yup.string().required('Comments are required'),
    });

    return (
        <GlobalDialogContent
            dialogBody={
                <Formik
                    initialValues={{ comments: '', role: '' }}
                    validationSchema={validationSchema}
                    onSubmit={async (values, { setSubmitting }) => {
                        setloading(true);
                        const normalizedStatus = status?.toLowerCase();
                        const finalStatus = normalizedStatus === 'approve' ? 'approved' : normalizedStatus === 'compliance' ? 'compliance' : 'rejected';
                        const submitPayload = {
                            tri_party_uuid: uuid,
                            status: finalStatus,
                            remark: values.comments
                        };
                        let response;
                        response = await UpdateTPMStatus(submitPayload);
                        const { code, message } = response;
                        if (code === 200) {
                            dispatch(closeDialog());
                            dispatch(setModuleRefresh({ moduleName: 'project_details', refresh: true }));
                            dispatch(showSnackbar({ type: 'success', message: message || 'Status Updated Successfully' }));
                        } else {
                            setloading(false);
                            dispatch(showSnackbar({ type: 'error', message: message || 'Something went wrong, please try again' }));
                        }
                    }}
                >
                    {({ errors, touched, isSubmitting, setFieldValue }) => (
                        <Form id="user-approval-form">
                            <Box mb={2}>
                                <Field
                                    as={TextField}
                                    name="comments"
                                    label="Comments *"
                                    fullWidth
                                    multiline
                                    rows={4}
                                    error={touched.comments && Boolean(errors.comments)}
                                    helperText={touched.comments && errors.comments}
                                />
                            </Box>
                        </Form>
                    )}
                </Formik>
            }
            dialogFooter={
                <Button
                    type="submit"
                    variant="contained"
                    color={status === 'Approve' ? 'success' : "error"}
                    form="user-approval-form"
                    disabled={loading}
                >
                    {loading ? 'Loading...' : status}
                </Button>
            }
        />
    );
}